import styled from 'styled-components';

import Icon from '../../Icon';

const SearchInput = styled.input`
  border: 0px;
  background-color: rgba(0,0,0,0);
  font-size: 12px;
  color: #787878;
  height: 30px;
  min-width: 20rem;
  text-align: center;
	padding-left: 32px;

	@media (max-width: 1500px) {
		min-width: 10rem;
	}
`;

const SearchIcon = styled(Icon)`
	margin: 0;
	position: absolute;
	top: 50%;
	left: 8px;
	transform: translateY(-50%);
`;

const SearchContainer = styled.div`
  margin: 15px auto;
  padding: 0;
  background-color: #F5F5F5;
  border-radius: 4px;
  position: relative;
`;

export {
	SearchInput,
	SearchIcon,
	SearchContainer
}
